export const SUPPLIES_PAYMENT_METHOD_REPLAY_BLOCK_CLASS =
  "supplies-payment-method-replay-block";

export const SUPPLIES_PAYMENT_METHOD_REPLAY_BLOCK_SELECTOR = `.${SUPPLIES_PAYMENT_METHOD_REPLAY_BLOCK_CLASS}`;
